import { UTModal, UTBox, UTTypography, UTButton } from '@group-link-one/gl-ui/utilities';

export interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
  isLoading?: boolean;
}

export const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'warning',
  isLoading = false,
}: ConfirmationDialogProps) => {
  const variantColors = {
    danger: {
      bg: 'rgba(220, 38, 38, 0.1)',
      border: 'rgba(220, 38, 38, 0.3)',
      text: '#991b1b',
    },
    warning: {
      bg: 'rgba(245, 158, 11, 0.1)',
      border: 'rgba(245, 158, 11, 0.3)',
      text: '#92400e',
    },
    info: {
      bg: 'rgba(59, 130, 246, 0.1)',
      border: 'rgba(59, 130, 246, 0.3)',
      text: '#1e40af',
    },
  };

  const colors = variantColors[variant];

  return (
    <UTModal
      title={title}
      open={open}
      onClose={onClose}
      hasButtonClose
      maxWidth='500px'
      content={
        <UTBox flexDirection='column' gap='24px' py='20px'>
          <UTBox
            backgroundColor={colors.bg}
            borderRadius='8px'
            padding='16px'
            border={`1px solid ${colors.border}`}
          >
            <UTTypography fontSize='15px' fontWeight='400' lineHeight='24px' color={colors.text}>
              {message}
            </UTTypography>
          </UTBox>

          <UTBox flexDirection='row' gap='12px' justifyContent='flex-end'>
            <UTButton
              variant='secondary'
              text={cancelText}
              onClick={onClose}
              disabled={isLoading}
            />
            <UTButton
              variant='primary'
              text={isLoading ? 'Processing...' : confirmText}
              onClick={onConfirm}
              disabled={isLoading}
              state={variant === 'danger' ? 'danger' : undefined}
            />
          </UTBox>
        </UTBox>
      }
    />
  );
};
